"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsFaded = void 0;
const createIsFaded = (highlightScope, highlightedItem) => item => {
  if (!highlightScope || !highlightedItem || !item) {
    return false;
  }
  if (highlightScope.fade === 'series') {
    return item.seriesId === highlightedItem.seriesId && item.dataIndex !== highlightedItem.dataIndex;
  }
  if (highlightScope.fade === 'global') {
    return item.seriesId !== highlightedItem.seriesId || item.dataIndex !== highlightedItem.dataIndex;
  }
  return false;
};
exports.createIsFaded = createIsFaded;